export default __webpack_public_path__ + "src/images/packages/ngama-tented-lodge/0292cf31090415f255b14ce73fb77ba7-4.jpg";